import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Yup from '@/utils/yup'
import Form from '@/components/forms/Form'
import { Column } from '@/components/layout'
import InputField from '@/components/forms/InputField'
import GoogleLoginButton from '@/components/Pages/SignUp/GoogleLoginButton'
import useResponsiveDimensions from '@/hooks/useResponsiveDimensions'
import WebAppLink from '@/components/common/WebAppLink'

import styles from './FreeTrialForm.module.scss'

const getMessageId = id => `pages.signUp.form.authenticate.${id}`

const UserLookup = ({
  saveAuthenticateData,
  handleGoogleAuth,
}) => {
  const schema = Yup.object({
    email: Yup.string().trim().lowercase().email('Invalid email format')
      .required('An email is required to continue.'),
  })

  const formRef = useRef(null)
  const formDimensions = useResponsiveDimensions(formRef)

  return (
    <>
      <h3 className={`text-center ${styles.cardHeading}`}>
        <FormattedMessage id={getMessageId('accountHeading')} />
      </h3>
      <Form
        ref={formRef}
        initialValues={{ email: '' }}
        onSubmit={saveAuthenticateData}
        schema={schema}
      >
        <Column alignCenter>
          <GoogleLoginButton
            onSuccess={handleGoogleAuth}
            width={Math.ceil(formDimensions.width)}
          />
        </Column>
        <div className={styles.orGoogle}>
          <span><FormattedMessage id={getMessageId('separator')} /></span>
        </div>
        <Column>
          <InputField
            data-testid="signup-email-input-field"
            helperProps={{
              'data-testid': 'email-validation-error',
            }}
            label="Email address"
            leftIconProps={{ name: 'mail', fill: 'gray' }}
            name="email"
            placeholder="you@company.com"
            size="large"
          />
        </Column>
        <Form.Action
          className={styles.submit}
          data-testid="signup-get-started-cta"
          messageId={getMessageId('nextButton')}
          size="large"
          type="submit"
        />
      </Form>
      <p className="text-center">
        Already have an account?{' '}
        <WebAppLink
          className={styles.noUnderline}
          eventTrackingProperties={{ location: 'Free Trial Authenticate' }}
          messageId="cta.login"
        />
      </p>
    </>
  )
}

UserLookup.propTypes = {
  saveAuthenticateData: PropTypes.func,
  handleGoogleAuth: PropTypes.func,
}

export default UserLookup
